(function () {
  'use strict';
  if (location.origin !== 'https://printpanoramics.co.uk' || !['189642178946','189643194754'].includes(String(window.Shopify?.theme?.id))) return;
  const origin='https://pp-studio-download-379251185001.europe-west2.run.app';
  class Photo extends HTMLElement {
    connectedCallback() { if(this.controller)return; this.controller=new AbortController(); void this.load(); }
    disconnectedCallback() { this.controller?.abort(); this.controller=null; if(this.url)URL.revokeObjectURL(this.url); }
    async load() {
      const controller=this.controller, message=this.querySelector('[data-pp-photo-message]'), link=this.querySelector('a');
      try {
        const u=new URL(link.href), p=new URLSearchParams(u.hash.slice(1)),id=p.get('file'),key=p.get('key');
        if(u.origin!==origin||u.pathname!=='/'||u.search||!/^[a-f0-9]{64}$/.test(id||'')||!/^pps2_[A-Za-z0-9_-]{42}[AEIMQUYcgkosw048]$/.test(key||'')||u.href!==origin+'/#file='+id+'&key='+key)throw Error();
        const r=await fetch(origin+'/file',{method:'POST',mode:'cors',credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',redirect:'error',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,key,kind:'preview'}),signal:AbortSignal.any([controller.signal,AbortSignal.timeout(45000)])});
        if(!r.ok||r.headers.get('content-type')!=='image/jpeg')throw Error(); const blob=await r.blob();
        if(!blob.size||blob.size>16*1024*1024||controller.signal.aborted||!this.isConnected)throw Error();
        const image=new Image(180,140);image.alt=this.dataset.alt;image.decoding='async';this.url=URL.createObjectURL(blob);image.src=this.url;await image.decode();
        if(controller.signal.aborted||!this.isConnected)throw Error();link.prepend(image);message.hidden=true;this.dataset.state='ready';
      } catch { if(this.isConnected){message.textContent=this.dataset.unavailable;this.dataset.state='unavailable';} }
    }
  }
  if(!customElements.get('pp-customer-photo'))customElements.define('pp-customer-photo',Photo);
})();


